<template lang="pug">
.briq-form-element
  label(for="color") Avatar
  .avatar-panel
    div
      .preview(:style="colorStyle") {{ avatarAbbreviation }}
    .activity-inputs
      BriqMultiselect(
        label="Color"
        :options="colors"
        v-model="innerColor"
        display="label"
        track-by="color"
        :disabled="disabled"
        selectLabel=""
        deselectLabel=""
      )
        template(slot="singleLabel" slot-scope="props")
          .color-option
            span.color-option-block(:style="{background: props.option.color}")
            span {{ props.option.label }}
        template(slot="option" slot-scope="props")
          .color-option
            span.color-option-block(:style="{background: props.option.color}")
            span {{ props.option.label }}
      BriqInput(
        data-test-id="abbreviation"
        label="Short reference"
        name="Abbreviation"
        v-model="innerLetters"
        :disabled="disabled"
        maxlength="2"
        )
</template>

<script>
export default {
  name: 'EditResourceAvatar',
  props: {
    colors: Array,
    color: String,
    abbreviation: String,
    disabled: Boolean,
    value: Object,
  },
  data() {
    return {
      innerColor: this.color,
      innerLetters: this.abbreviation,
    }
  },
  computed: {
    colorStyle() {
      return {
        backgroundColor: this.innerColor || 'black',
      }
    },
    avatarAbbreviation() {
      return this.innerLetters || '--'
    },
  },
  watch: {
    innerColor(newVal) {
      this.$emit('updateColor', newVal)
    },
    innerLetters(newVal) {
      this.$emit('updateLetters', newVal)
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.avatar-panel
  display flex
  border-radius 3px
  border solid 1px borderColor
  padding 20px

.preview
  {typeBold}
  display inline-block
  width 40px
  height 40px
  background-color rgb(105, 215, 196)
  color white
  text-transform uppercase
  line-height 40px
  text-align center
  vertical-align middle
  border-radius 6px
  margin-right 20px

.activity-inputs
  padding-left 20px
  border-left 1px solid borderColor

.color-option-block
  width 19px
  height 19px
  border-radius 3px
  display inline-block
  margin-right 10px

.color-option
  display flex
  align-items center
</style>
